import moment from 'moment';

export const APP_CONTEXT = 'BROKERAGE';

export const EVENT_SERVICE_DEVICE_TYPE = 'transporter_central';

export const CSV_LINE_NUMBER_PADDING = 2;

export const MEASUREMENT_UNITS = {
  KG: 'KG',
};

export const BE_DEFAULT_NIL_KSUID = '000000000000000000000000000';

export const SERVICES_URL = {
  AUTH: window.AUTH_SERVICE_URL,
  EVENT: window.EVENT_SERVICE_URL,
  LOAD: window.LOAD_SERVICE_URL,
  LTMS: window.LTMS_SERVICE_URL,
  LTMS_PUBLIC: window.LTMS_SERVICE_URL_PUBLIC,
  MASTER_SERVICE: window.MASTER_SERVICE_URL,
  PANTHERA: window.PANTHERA_SERVICE_URL,
  PAYMENT: window.PAYMENT_SERVICE_URL,
  PROFILE: window.PROFILE_SERVICE_URL,
  PROFILE_PUBLIC: window.PROFILE_SERVICE_URL_PUBLIC,
} as const;

export const USER_ACCESS_TYPE = {
  ACCOUNT_PAYABLE: 'ACCOUNT_PAYABLE',
  ADMIN: 'ADMIN',
  AR: 'AR',
  DOCUMENT_COLLECTION: 'DOCUMENT_COLLECTION',
  FINANCE_ADMIN: 'FINANCE_ADMIN',
  FINANCE: 'FINANCE',
  FULL_ACCESS: 'FULL_ACCESS',
  KARGO_SHIPPER_SALES: 'KARGO_SHIPPER_SALES',
  RESTRICTED_ACCESS: 'RESTRICTED_ACCESS',
  SALES_SUPPORT: 'SALES_SUPPORT',
  SALES: 'SALES',
  TRAFFIC_CONTROLLER: 'TRAFFIC_CONTROLLER',
  TRANSPORT_PLANNER: 'TRANSPORT_PLANNER',
  VENDOR_MANAGEMENT: 'VENDOR_MANAGEMENT',
} as const;

const INDONESIA_TIMEZONE = {
  '+0700': 'WIB',
  '+0800': 'WITA',
  '+0900': 'WIT',
};

const currentTimezone = INDONESIA_TIMEZONE[moment().format('ZZ')] as string;
export const DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_WITH_SHORT_MONTH_FORMAT = 'DD MMM YYYY';
export const DATE_TIME_FORMAT = `DD MMM YYYY, HH:mm [${currentTimezone}]`;
export const DATE_TIME_FORMAT_CSV = 'DD-MM-YYYY HH:mm:ss';
export const DOCUMENT_DATE_FORMAT_TO_API = 'YYYY-MM-DD';
export const LOG_DATE_FORMAT = 'DD MMMM YYYY';
export const TIME_FORMAT = `HH:mm [${currentTimezone}]`;
export const WIB_TIMEZONE = '+07:00';
export const TIME_REGEX_PATTERN = /^(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)$/; // HH:MM:SS in 24 hour format

export const LAST_MILE_LOGIN_DATA = 'lastMileLoginData';
export const DAYS_OF_WEEK = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

export const FEATURE_FLAG = {
  ACTUAL_PRICING_UNIT_DO_LEVEL: 'LM-2382_PRICING_DO_LEVEL',
  ACTUAL_RECEIVER_NAME_AWB: 'LM-2523_ACTUAL_RECEIVER_NAME_AWB',
  ADD_IDENTIFIER_PROJECT: 'LM-4113_ADD-IDENTIFIER-PROJECT',
  ALLOCATION_ADDITIONAL_TRIP: 'LM-4247_ALLOCATION_ADDITIONAL_TRIP',
  ALLOCATION_ADDITIONAL_TRIP_NOTES: 'LM-4247_ALLOCATION_ADDITIONAL_TRIP_NOTE',
  AWB_EDIT_STATUS_FORM: 'LM-3677_AWB_EDIT_STATUS_FORM',
  AWB_SHIPMENT_NOTES: 'LM-2110_AWB_SHIPMENT_NOTES',
  BANK_ACCOUNT_HOLDER: 'LM-4830_BANK_ACCOUNT_HOLDER',
  BULK_DOWNLOAD_INVALID_CSV: 'LM-2530_BULK_DOWNLOAD_INVALID_CSV',
  CUSTOMER_ACTIVITY_LOG: 'LM-2865_CUSTOMER_ACTIVITY_LOG',
  DAILY_INCENTIVE_PRICE_ON_CONTRACT: 'LM-2936_DAILY_INCENTIVE_PRICE_ON_CONTRACT',
  DAILY_RENTAL_PRICE_ON_CONTRACT: 'LM-2931_DAILY_RENTAL_PRICE_IN_CONTRACT',
  DEDICATED_ALL_IN_MULTIPLE_PROJECT: 'LM-2528_DEDICATED_ALL_IN_MULTIPLE_PROJECT',
  DISBURSEMENT_ERROR_CODE: 'KC-4494_DISBURSEMENT_ERROR_CODE',
  DO_ALLOCATION_BETWEEN_CONTRACTS: 'LM-2251_DO_ALLOCATION_BETWEEN_CONTRACTS',
  DO_ASSIGN_FORM: 'LM-3677_DO_ASSIGN_FORM',
  DO_AWB_DETAIL_CUSTOMER_PAGE: 'LM-2862_DO_AWB_DETAIL_CUSTOMER_PAGE',
  DO_AWB_DETAIL_CUSTOMER_PAGE_ACTION_BUTTON: 'LM-2866_DO_AWB_DETAIL_CUSTOMER_PAGE_ACTION_BUTTON',
  DO_AWB_DETAIL_SHIPMENT_PAGE: 'LM-2870_DO_AWB_DETAIL_SHIPMENT_PAGE',
  DO_DETAIL_RENTAL_DAILY: 'LM-2383_DO_DETAIL_RENTAL_DAILY',
  DO_PLANNED_PRICING_UNIT: 'LM-2379_DO_PLANNED_PRICING_UNIT',
  DRIVER_LICENSE_TYPE_ENUM: 'LM-DRIVER_LICENSE_TYPE_ENUM',
  ERROR_MESSAGE_IMPROVEMENT: 'LM-2852_ERROR_MESSAGE_IMPROVEMENT',
  ETA_ETD_DESTINATION: 'LM-3110_ETA_ETD_DESTINATION',
  FETCH_STAGE_WORKING_DAYS: 'LM-4305_FETCH_STAGE_WORKING_DAYS',
  FILTER_EXPIRED_CONTRACT: 'LM-4323_FILTER_EXPIRED_CONTRACT',
  HOLD_CANCEL_CATEGORY: 'LM-5041_HOLD_CANCEL_CATEGORY',
  LOADING_DATE_TIME_INPUT: 'LM-3103_LOADING_DATE_TIME_INPUT',
  MASTER_SUPPLY_TRACKER_PHASE_2: 'LM-4320_MASTER_SUPPLY_TRACKER_PHASE_2',
  MONITORING_COMPLETED_BY_DRIVER: 'LM-3736_MONITORING_COMPLETED_BY_DRIVER',
  MONITORING_COMPLETED_DRIFT: 'LM-3736_MONITORING_COMPLETED_DRIFT',
  MONITORING_CONFIRMED_TIME_STAMP: 'LM-3941_MONITORING_CONFIRMED_TIME_STAMP',
  NEW_ADJUSTMENT_TYPE: 'LM-4540_NEW_ADJUSTMENT_TYPE',
  ORDER_REFERENCE_AWB: 'LM-2522_ORDER_REFERENCE_AWB',
  PAYABLE_COUNT_SUMMARY: 'LM-2173_PAYABLE_COUNT_SUMMARY',
  PAYABLE_DRIVER_NAME: 'LM-2938_DRIVER_NAME_IN_PAYABLE',
  PAYABLE_LIST_FILTER: 'LM-3160_FILTER_PAYABLE_LIST',
  PRICING_SCHEME_COLUMN_AND_FILTER: 'LM-2385_PRICING_SCHEME_RECEIVABLE_FLEET',
  PROJECT_CLUSTER: 'LM-2118_PROJECT_CLUSTER',
  PROJECT_PROVINCE_AND_CITY: 'LM-2119_PROJECT_PROVINCE_AND_CITY',
  RECEIVABLE_FLEET_SHIPMENT_DATE: 'LM-2387_RECEIVABLE_FLEET_SHIPMENT_DATE',
  REMOVE_PAYMENT_ACTION_RESTRICTION: 'LM-4435_REMOVE_PAYMENT_ACTION_RESTRICTION',
  RESYNC_SHIPPER_PAYABLES_ITEMS: 'LM-2736_RESYNC_SHIPPER_PAYABLES_ITEMS',
  REVIEW_PAYABLE_ITEMS_AMOUNT: 'LM-3262_REVIEW_PAYABLE_ITEMS_AMOUNT',
  SEARCH_AND_FILTER_V2_DRIVER: 'LM-1968_SEARCH_AND_FILTER_V2_DRIVER',
  SEARCH_AND_FILTER_V2_FLEET: 'LM-1969_SEARCH_AND_FILTER_V2_FLEET',
  SEARCH_AND_FILTER_V2_LOCATION: 'LM-1966_SEARCH_AND_FILTER_V2_LOCATION',
  SEARCH_AND_FILTER_V2_MONITORING: 'LM-1963_SEARCH_AND_FILTER_V2_MONITORING',
  SEARCH_AND_FILTER_V2_PROJECT: 'LM-1962_SEARCH_AND_FILTER_V2_PROJECT',
  SEARCH_AND_FILTER_V2_ROUTING: 'LM-1965_SEARCH_AND_FILTER_V2_ROUTING',
  SEARCH_AND_FILTER_V2_TRANSPORTER: 'LM-1970_SEARCH_AND_FILTER_V2_TRANSPORTER',
  SEARCH_PAYABLE_SHIPPER_NAME: 'LM-2100_SEARCH-PAYABLES-SHIPPER-NAME',
  SHARE_PAYMENT_STATEMENT: 'LM-4720_LM-4721_SHARE_PAYMENT_STATEMENT',
  SHIPMENT_ACTIVITY_LOG: 'LM-3107_SHIPMENT_ACTIVITY_LOG',
  SHIPMENT_DISPATCH: 'LM-4325_SHIPMENT_DISPATCH',
  SHIPMENT_STATUS_UNFULFILLED: 'LM-2732_NEW_SHIPMENT_STATUS_UNFULFILLED',
  SHIPPER_CONTRACT_UPLOAD: 'LM-4886_SHIPPER_CONTRACT_UPLOAD',
  SHIPPER_PROJECT_ADDITIONAL_COLUMN: 'LM-5184_ADDITIONAL_SHIPPER_PROJECT',
  SHOW_CONTRACT_KSUID_AT_PIPELINE: 'LM-5451_SHOW_CONTRACT_KSUID_AT_PIPELINE',
  TPT_DEDICATED_REVIEW_DO_LIST: 'LM-3278_TPT_DEDICATED_REVIEW_DO_LIST',
  TPT_DEDICATED_REVIEW_TIP_FEE_TYPE: 'LM-3259_TPT_DEDICATED_REVIEW_TIP_FEE_TYPE',
  TPT_PAYABLE_REVIEW_CANCEL_PAYMENT_ACTION: 'LM-3294_TPT_PAYABLE_REVIEW_CANCEL_PAYMENT_ACTION',
  TRANSPORTER_ONCALL: 'LM-2241_TPT_ONCALL',
  TRANSPORTER_PIPELINE: 'LM-4064_TRANSPORTER_PIPELINE',
  TRANSPORTER_PIPELINE_HAS_TIP_PAYMENT_SCHEME: 'LM-4069_TRANSPORTER_PIPELINE_HAS_TIP_PAYMENT_SCHEME',
  TRANSPORTER_PIPELINE_IMPROVEMENT: 'LM-5153_TRANSPORTER_PIPELINE_IMPROVEMENT',
  TRANSPORTER_PIPELINE_IMPROVEMENT_CONTRACT: 'LM-5154_TRANSPORTER_PIPELINE_IMPROVEMENT_CONTRACT',
  UPLOAD_AWB_RESTRICTION: 'LM-3632_UPLOAD_AWB_RESTRICTION',
  UPLOAD_ITEM_DETAILS_RESTRICTION: 'LM-3633_UPLOAD_ITEM_DETAILS_RESTRICTION',
  VCC_V2: 'LM-5066_LTMS_FE_VCC_V2',
  VEHICLE_DRIVER_ALLOCATION: 'LM-1921_Vehicle_Driver_Allocation',
  VIEW_AND_DOWNLOAD_PAYMENT_STATEMENT: 'LM-4536_VIEW_AND_DOWNLOAD_PAYMENT_STATEMENT',
  VIEW_AND_FILTER_PKP_ON_PAYABLE_LIST: 'LM-4436_VIEW_AND_FILTER_PKP_ON_PAYABLE_LIST',
  KC_LTMS_RECEIVABLE_UPI_MIGRATION: 'KC_LTMS_RECEIVABLE_UPI_MIGRATION',
};
